import api from "../api";
import { API_URL } from "../constants";

type GetApplicationsParams = {
  limit: number;
  offset: number;
  search?: string;
  category?: string | null;
};

export const getApplications = ({
  limit,
  offset,
  search,
  category,
}: GetApplicationsParams) => {
  const query = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });

  if (search) {
    query.set("search", search);
  }

  if (category) {
    query.set("category", category);
  }

  return api.get(`${API_URL}/v1/applications?${query.toString()}`);
};
